import { connect } from 'react-redux';
import MNewOrdersPage from './MNewOrdersPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rework } from 'src/actions/liveOrderAction';
// import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getMNewOrderData } from 'src/actions/manufacturAction';

export const mapStateToProps = (state: AppState) => {
    return {
        mNewOrderData: state.manufactur.mNewOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getHoldOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getMNewOrderData);
        },
        reload: () => {
            dispatch(getMNewOrderData);
        },
        // onRowClick: (orderid: string, rowData: string) => {
        //     dispatch(rowClick(orderid, rowData));
        // },
        // onDownloadClick: (filepath: string, fileName: string) => {
        //     dispatch(downloadURL(filepath, fileName, 'initial'));
        // },
        submitCancel: (column: Object) => {
            dispatch(rework(column, 'mnew'));
        },
    };
};

const MNewOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MNewOrdersPage);

export default MNewOrderContainer;



// WEBPACK FOOTER //
// ./src/components/MNewOrdersPage/MNewOrdersPageContainer.tsx